export const capitalizeFirstLetter = (value: string, lastToLower?: boolean) =>
    `${value.charAt(0).toUpperCase()}${lastToLower ? value.slice(1).toLowerCase() : value.slice(1)}`
